import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, utf8hex_to_string } from '../../common'
import * as qs from 'querystring'

$(init)

async function init () {
  let $page = $('#reset-password-page')
  if ($page.length == 0) {
    return
  }
  try {
    let query = qs.parse(location.search.substring(1))
    let is_valid = true
    let email = ''
    try {
      email = utf8hex_to_string(query.u||'')
    } catch (err) {
      is_valid = false
    }
    try {
      is_valid = is_valid && (await post_json('users/is-reset-password-valid', { email, token: query.t })).is_valid
    } catch (err) {
      if (err.code != 1001) {
        alert_error(err)
        return
      }
      is_valid = false
    }
    if (!is_valid) {
      $page.find('.invalid-msg').removeClass('d-none')
      $page.find('.reset-password-form').addClass('d-none')
    }
    $page.removeClass('page-not-ready').addClass('page-ready')
    $page.find('.reset-password-form input[name=email]').prop('value', email)
    $page.find('.reset-password-form').on('submit', async ($evt) => {
      $evt.preventDefault()
      $page.find('.reset-password-form button').prop('disabled', true)
      try {      
        let pass = $page.find('.reset-password-form [name=password]').val()
        let cpass = $page.find('.reset-password-form [name=confirm_password]').val()
        if (!pass) {
          throw { message: 'Please enter a password.' }
        }
        if (pass != cpass) {
          throw { message: 'Confirm password do not match.' }
        }
        await post_json('users/reset-password', { email, token: query.t, password: pass })
        $page.find('.reset-password-form').addClass('d-none')
        $page.find('.success-msg').removeClass('d-none')
        $('#login-modal').on('show.bs.modal', () => {
          window.location = '/'
        })
      } catch (err) {
        alert_error(err)
      } finally {
        $page.find('.reset-password-form button').prop('disabled', false)
      }
    })
  } catch (err) {
    alert_error(err)
  }
}
